import { render } from "./ChooseCategory.vue?vue&type=template&id=0b3e7e10&scoped=true"
import script from "./ChooseCategory.vue?vue&type=script&lang=js"
export * from "./ChooseCategory.vue?vue&type=script&lang=js"

import "./ChooseCategory.vue?vue&type=style&index=0&id=0b3e7e10&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3e7e10"]])

export default __exports__